import { useApp } from "../../contexts/AppContext";
import { ORG } from "../../data/initialData";
import { FIREBASE_READY } from "../../firebase";

export default function OverviewTab() {
  const { posts, projects, about } = useApp();

  return (
    <div>
      <div className="acard">
        <div className="atitle">Dashboard Overview</div>
        <div className="stat-grid">
          {[
            { num: posts.length,                          lbl: "Total Posts" },
            { num: posts.filter(p => p.published).length, lbl: "Published"   },
            { num: projects.length,                       lbl: "Projects"    },
            { num: about.officers.length,                 lbl: "Officers"    },
          ].map((s, i) => (
            <div key={i} className="stat-card">
              <div className="stat-num">{s.num}</div>
              <div className="stat-lbl">{s.lbl}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="acard">
        <div className="atitle">Organization Details</div>
        <div style={{ display:"grid", gap:".6rem", fontSize:".88rem" }}>
          {[
            ["Name",     ORG.name],
            ["Inc. No.", ORG.incNo],
            ["Location", ORG.location],
            ["Trustee",  ORG.trustee],
            ["Email",    ORG.email],
            ["Founded",  ORG.foundingDate],
          ].map(([k, v]) => (
            <div key={k} style={{ display:"flex", gap:"1rem", padding:".5rem 0", borderBottom:"1px solid var(--br)" }}>
              <div style={{ fontWeight:700, minWidth:140, color:"var(--gr)", fontSize:".75rem", textTransform:"uppercase", letterSpacing:".06em" }}>{k}</div>
              <div>{v}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="acard" style={{
        background: FIREBASE_READY
          ? "linear-gradient(135deg,var(--gd),var(--b))"
          : "linear-gradient(135deg,#b71c1c,#c62828)",
        color: "#fff" }}>
        <div style={{ fontFamily:"'Playfair Display',serif", fontSize:"1.1rem", marginBottom:".5rem" }}>
          {FIREBASE_READY ? "✅ Firebase Connected" : "⚠️ Firebase Not Configured"}
        </div>
        <p style={{ opacity:.85, fontSize:".88rem" }}>
          {FIREBASE_READY
            ? "Data syncs to Firestore. Images stored in Firebase Storage. All changes are visible to every user instantly."
            : "Data is saved to this browser only. Add your Firebase credentials to .env.local to enable persistent cloud storage and secure login."}
        </p>
      </div>
    </div>
  );
}
